export default function SRReportSchedulesController() { /* provided only for controllerAs binding */ }
